import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import { useUserLocation } from '~/context/common/UserContext';

export default function useSendZipCodeChanges() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { zip } = useUserLocation();
  const previousZip = useRef(zip);

  useSubsequentEffect(() => {
    trackEvent('zip code changed', {
      previousZip: previousZip.current,
      newZip: zip
    });
    previousZip.current = zip;
  }, [trackEvent, zip]);
}
